export const METRICS_PREFIX = 'predict_default'
export const METRIC_PREFIX = 'predict_'
export enum MetricGroupValue {
	Decreased = 'decreased',
	Increased = 'increased',
	Locked = 'locked',
	NotChanged = 'not_changed',
	RuleBased = 'rule_based_repricing',
	DemandBased = 'demand_based_repricing',
	Manual = 'manual_repricing',
	Markdown = 'markdown_repricing',
	Promo = 'promo_repricing',
}
export enum MetricGroup {
	PriceChangeStatus = 'price_change_status',
	PricingType = 'pricing_type',
	WithDiscount = 'with_discount',
}
export enum MetricName {
	DiscountInit = 'discount_init',
	DiscountFinal = 'discount_final',
	MarginFinal = 'margin_final',
	MarginInit = 'margin_init',
	PricngLineCount = 'pricng_line_count',
	ProductCount = 'product_count',
}
export const GROUP_VALUE_COLORS: Partial<Record<MetricGroupValue, string>> = {
	[MetricGroupValue.Decreased]: 'bg-orange-500',
	[MetricGroupValue.Increased]: 'bg-violet-500',
	[MetricGroupValue.NotChanged]: 'bg-green-500',
	[MetricGroupValue.Locked]: 'bg-slate-500',
}
export enum MetricDataType {
	/**
	 * Relative
	 */
	Percent = 'percent',
	/**
	 * Absolute
	 */
	Number = 'number',
	/**
	 * Percent points
	 */
	PercentPoint = 'pp',
	/**
	 * Unit
	 */
	Unit = 'unit',
}
